const reduxStoreExternal = { sourceData: {}, content: {} };
export default reduxStoreExternal;
